import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {WidgetSettingsService} from '../../../components/layout/widget/widget-settings-service';
import {DexLpCollapsedWidgetSettings, DexLpCollapsedWidgetSettingsDef} from './dex-lp-collapsed-widget-settings';

@Injectable()
export class DexLpCollapsedWidgetSettingsService implements WidgetSettingsService {

    public getDefaultSettings(): Observable<DexLpCollapsedWidgetSettings> {
        const defaultWidgetSettings: DexLpCollapsedWidgetSettings = {
            title: null
        };

        return of(defaultWidgetSettings);
    }

    public fromDefinition(settingsDef: DexLpCollapsedWidgetSettingsDef): Observable<DexLpCollapsedWidgetSettings> {
        return of<DexLpCollapsedWidgetSettings>({
            title: settingsDef.title
        });
    }

    public toDefinition(settings: DexLpCollapsedWidgetSettings): DexLpCollapsedWidgetSettingsDef {
        return {
            title: settings.title
        };
    }

}
